import { useAxios } from "./api";
const basePath = "/api/v1/branches";
export const endpoint = {
  getBranches: { path: `${basePath}`, method: "GET" },
  getBranchById: { path: (id) => `${basePath}/${id}`, method: "GET" },
};

export const useGetBranches = () => {
  return useAxios(
    {
      url: endpoint.getBranches.path,
      method: endpoint.getBranches.method,
    },
    { manual: true }
  );
};
export const useGetBranchById = () => {
  return useAxios(
    {
      method: endpoint.getBranchById.method,
    },
    { manual: true }
  );
};